export default "__VITE_ASSET__BRk_Dh5O__"